import CrudController from "./crud_controller";

export default class extends CrudController {
  static targets = ["form", "submitButton","keysFlag", "keysFlagHidden",
  ]

  SITE_TYPES = [];
  REGIONS = [];
  TIME_ZONES = [];

  connect() {

    this.formTarget.addEventListener("submit", e =>
    {
      this.keysFlagHiddenTarget.value = (this.keysFlagTarget.checked) ? "1" : "0"
    })
  }

  handleEdit(event)
  {
      if (event.detail[0].success)
      {
          const editEvent = new CustomEvent("show-toast", { detail: "Site successfully updated!" });
          window.dispatchEvent(editEvent);

          let { siteNum, devNum } = this.element.dataset

          setTimeout(() =>
          {
            Turbolinks.visit(window.App.prefixedUrl(`/sites/${siteNum}?active_dev_num=${devNum}`))
          }, 500);
      }
      else
      {
        const errorEvent = new CustomEvent("show-toast", { detail: "An error occurred: " + event.detail[0].error })
        window.dispatchEvent(errorEvent);
      }
  }
}